const getStatusColor = (status: string) => {
  switch (status.toLowerCase()) {
    case "hot":
      return "bg-red-100 text-red-800 border-red-200";
    case "warm":
      return "bg-orange-100 text-orange-800 border-orange-200";
    case "cold":
      return "bg-blue-100 text-blue-800 border-blue-200";
    case "converted":
      return "bg-green-100 text-green-800 border-green-200";
    case "new lead":
    case "leads":
      return "bg-blue-100 text-blue-800 border-blue-200";
    case "contacted":
      return "bg-yellow-100 text-yellow-800 border-yellow-200";
    case "qualified":
      return "bg-purple-100 text-purple-800 border-purple-200";
    case "proposal":
      return "bg-indigo-100 text-indigo-800 border-indigo-200";
    case "negotiation":
      return "bg-orange-100 text-orange-800 border-orange-200";
    case "closed won":
      return "bg-green-100 text-green-800 border-green-200";
    case "closed lost":
      return "bg-red-100 text-red-800 border-red-200";
    case "appt":
    case "scheduled":
      return "bg-cyan-600 text-cyan-100 border-cyan-500";
    case "underwriting":
    case "under writing":
      return "bg-amber-500 text-amber-100 border-amber-400";
    case "sold & approved":
    case "approved":
      return "bg-emerald-600 text-emerald-100 border-emerald-500";
    case "no sale":
      return "bg-red-600 text-red-100 border-red-500";
    case "bad number":
    case "bad #":
      return "bg-red-500 text-red-100 border-red-400";
    case "do not call":
      return "bg-amber-800 text-amber-100 border-amber-700";
    case "declined":
      return "bg-gray-600 text-gray-100 border-gray-500";
    case "lapsed":
      return "bg-gray-900 text-gray-100 border-gray-800";
    case "disposed":
      return "bg-gray-600 text-gray-100 border-gray-500";
    default:
      return "bg-gray-600 text-gray-100 border-gray-500";
  }
};

export default getStatusColor;
